import { UserType } from '../../../../../user-profile';

export enum UserFields {
    title= 'title',
    firstName='firstName',
    lastname='lastName',
    email='email',
    currentPassword='currentPassword',
    newPassword='newPassword',
    confirmPassword='confirmPassword'
}

type UserProfileFormFields = {
    currentPassword?: string
    newPassword?: string
    confirmPassword?: string
};

export type UserProfileModalState = {
    data: null
    isLoading: boolean
    isError: boolean
    isSuccess: boolean
    error: {
        message: string
        code: string
        originalError: object
        status: number
    } | null
};

export type ProfileFormType = UserType & UserProfileFormFields;

export type ToastVariantsType = 'success' | 'error' | 'warning' | 'info';

export enum ToastVariants {
    success = 'success',
    error = 'error',
    warning = 'warning',
    info = 'info'
}
